import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const convertDate = (date) => {
  if (!date) return '';

  const parsedDate = dayjs(date, 'YYYY-MM-DD HH:mm:ss', true);

  return parsedDate.isValid()
    ? parsedDate.format('DD.MM.YYYY HH:mm')
    : date;
};
export class NotificationsApiConverter {
  convertNotifications = (data) => {
    const convertedData = data.notifications.map((item) => ({
      id: item?.id,
      tag: item?.tag?.toLowerCase(),
      text: item?.text,
      date: convertDate(item?.created_at),
      new: item?.is_new,
      isAuto: item?.is_auto,
      img: item?.img_url,
    }));

    return convertedData;
  };

  convertNotificationsCount = (data) => data.total;
}
